module.exports = __webpack_public_path__ + "static/img/browser2.40bccf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/browser2.png
// module id = rkiU
// module chunks = 3